import React from "react";
import { Link } from "react-router-dom";
import { FiLogIn } from "react-icons/fi";

export default function LoginRequired() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white shadow-lg rounded-xl overflow-hidden">
        <div className="bg-sky-800 p-4 text-white">
          <h2 className="text-xl font-bold">Acceso Requerido</h2>
        </div>
        
        <div className="p-6 text-center">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <FiLogIn className="text-red-500 text-2xl" />
          </div>
          
          <h3 className="text-lg font-semibold text-gray-800 mb-2">Inicia sesión para continuar</h3>
          <p className="text-gray-600 mb-6">
            La función "Pedir de nuevo" está disponible solo para usuarios registrados.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-gray-800 transition-colors"
            >
              Volver al inicio
            </Link>
            <Link
              to="/"
              className="px-4 py-2 bg-sky-600 hover:bg-sky-700 rounded-lg text-white transition-colors flex items-center justify-center gap-2"
            >
              <FiLogIn />
              Iniciar sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

